/**
 * Returns alt text from Contentful Image Asset title
 * Roadside / Benefits / Unlimited Service Calls / Image / alt=Hagerty service call representative
 */
export const getAltText = (text: string) => {
  const altText = text.match(/alt=(.*)/);
  return altText?.length ? altText[1] : null;
};
